<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
          <v-card-title class="primary white--text title">
              {{'Change Password'|translate}}
          </v-card-title>
          <v-card-text>
              <v-text-field :label="'User Name'|translate" disabled v-model="activeItem.user_name"></v-text-field>
              
              <!-- Password security requirements help text -->
              <v-alert type="info" value="true" outline class="mb-3">
                <small>{{getPasswordSecurityMessage()}}</small>
              </v-alert>
              
              <v-text-field :label="'New Password'|translate" autofocus v-model="new_password" type="password"></v-text-field>
              <v-text-field :label="'Confirm New Password'|translate" v-model="check_password" type="password"></v-text-field>
               <span v-show="!password_matched" class="error--text">{{password_validation_message}}</span>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outline class="mr-2" @click="initializeVar(true)">{{'Cancel'|translate}}</v-btn>
              <v-btn class="primary mr-2 elevation-4" @click="addRecord()" :disabled="!password_matched">{{'Save'|translate}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {putUser, putCurrentUser} from '../../helper'
  import {sameAs} from 'vuelidate/lib/validators'
  import { mapGetters } from 'vuex'
  import passwordValidationMixin from '../mixins/passwordValidation'

  import Vue from 'vue'
  import SimpleVueValidation from 'simple-vue-validator'
  const Validator = SimpleVueValidation.Validator
  Vue.use(SimpleVueValidation)


  export default {
    mixins: [passwordValidationMixin],
    components: { },
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.activeItem = this.item
        }
      },
      value () {
        if (!this.activeItem || !this.activeItem.user_id) {
          this.initializeVar()
        }
        if (this.dialog !=this.value){
          this.dialog=this.value
          this.activeItem=this.item
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    computed: {
      ...mapGetters([
        'minimumPasswordLength',
        'passwordRequiredCharacterSets',
        'passwordBlockCommonWords',
        'passwordBlockPersonalInfo',
        'passwordBlockSequentialChars',
      ]),
      isCurrentUser () {
        // Check if this is the current user by comparing with store
        // If activeItem doesn't have user_id, it's likely the current user from getCurrentUser()
        if (!this.activeItem) return false
        
        if (!this.activeItem.user_id) {
          // When opened from UserProfileDialog, activeItem comes from getCurrentUser() and has no user_id
          return true
        }
        
        // When opened from Users.vue, compare with current user in store
        return this.$store.state && this.$store.state.userStore && 
               this.$store.state.userStore.user && this.$store.state.userStore.user.content &&
               this.$store.state.userStore.user.content.user_name === this.activeItem.user_name
      },
      password_matched () {
        if (this.new_password==''){
          return false
        }
        if (this.new_password.length < this.minimumPasswordLength) {
          return false
        }
        if (!this.isPasswordCharacterSetsValid(this.new_password, this.passwordRequiredCharacterSets)) {
          return false
        }
        // Enhanced security validation
        const config = {
          minimumPasswordLength: this.minimumPasswordLength,
          passwordRequiredCharacterSets: this.passwordRequiredCharacterSets,
          passwordBlockCommonWords: this.passwordBlockCommonWords,
          passwordBlockPersonalInfo: this.passwordBlockPersonalInfo,
          passwordBlockSequentialChars: this.passwordBlockSequentialChars
        };
        const securityCheck = this.isPasswordSecure(this.new_password, this.activeItem, config);
        if (!securityCheck.valid) {
          return false
        }
        return this.new_password==this.check_password
      },
      password_validation_message () {
        const config = {
          minimumPasswordLength: this.minimumPasswordLength,
          passwordRequiredCharacterSets: this.passwordRequiredCharacterSets,
          passwordBlockCommonWords: this.passwordBlockCommonWords,
          passwordBlockPersonalInfo: this.passwordBlockPersonalInfo,
          passwordBlockSequentialChars: this.passwordBlockSequentialChars
        };
        return this.getPasswordValidationMessage(this.new_password, this.check_password, this.activeItem, config);
      }
    },
    mounted () {
      this.dialog = this.value
    },
    data () {
      return {
        dialog: false,
        activeItem: {
          user_name: '',


        } ,
        new_password:  '',
        check_password: '',
      }
    },

    validators: {
      password: function (value) {
        return Validator.value(value).required().minLength(this.minimumPasswordLength);
      },
      'repeat, password': function (repeat, password) {
        if (this.submitted || this.validation.isTouched('repeat')) {
          return Validator.value(repeat).required().match(password);
        }
      }
    },

    methods: {
      submit: function (){
        this.submitted =true;
        this.$validate()
          .then(function(success){
            if (success){
              alert(this.$options.filters.translate('Validation succeeded!'))
            }
          })
      },

      initializeVar(close) {
        this.activeItem = {
          user_name:  '',
          new_password: '',
          check_password: ''
          }
          this.new_password = ''
          this.check_password = ''
          if(close) {
              this.dialog = false;
          }
      },
      addRecord () {
        if (this.isCurrentUser) {
          // Use putCurrentUser for current user
          putCurrentUser(
            {
              'email': this.activeItem.email,
              'user_name': this.activeItem.user_name,
              'password': this.new_password,
            }
          )
        } else {
          // Use putUser for admin changing other users' passwords
          putUser(
            {
              'user_id': this.activeItem.user_id,
              'email': this.activeItem.email,
              'user_name': this.activeItem.user_name,
              'updated_on': this.activeItem.updated_on,
              'created_on': this.activeItem.created_on,
              'role': this.activeItem.role,
              'password': this.new_password,
            }
          )
        }
        this.dialog=false
      }
    },

    validations: {
      check_password:{
        sameAsPassword: sameAs('new_password')
      }
    },
    name: 'ChangePasswordDialog'
  }



</script>

<style scoped>

</style>

